module.exports = __webpack_public_path__ + "img/body_repairs.fcbb943a.png";